import { decodeHtml } from './decode';

export const removeHtml = (input: string = '') => decodeHtml(input).replace(/<\/?[^>]+(>|$)/g, '');
